export const upTrendingConstants = {
  GET_UP_TRENDING_FAILURE: "GET_UP_TRENDING_FAILURE",
  GET_UP_TRENDING_SUCCESS: "GET_UP_TRENDING_SUCCESS",

  GET_UP_TRENDING_BY_ID_SUCCESS: "GET_UP_TRENDING_BY_ID_SUCCESS",
  GET_UP_TRENDING_BY_ID_FAILURE:"GET_UP_TRENDING_BY_ID_FAILURE",
};
